import "./front/zukan/bundle"
import "./front/zukan/objectfit"
import "./front/zukan/intersection-observer"